const NL_WHITESPACE = /\s/;
function isNaturalLanguage(s) {
    return NL_WHITESPACE.test(s);
}
function stepVerbAndArg(step) {
    if (step === null || step === undefined || typeof step !== 'object' || Array.isArray(step)) {
        return undefined;
    }
    const entries = Object.entries(step);
    if (entries.length === 0)
        return undefined;
    const first = entries[0];
    return { verb: first[0], arg: first[1] };
}
function scanSteps(steps, where, out) {
    if (!Array.isArray(steps))
        return;
    steps.forEach((step, i) => {
        const parsed = stepVerbAndArg(step);
        if (!parsed)
            return;
        if (typeof parsed.arg === 'string' && isNaturalLanguage(parsed.arg)) {
            out.push({ path: `${where}.steps.${i}.${parsed.verb}`, text: parsed.arg });
        }
    });
}
/**
 * Walk a parsed .remedy doc and produce the list of text slots that SPEC §5
 * names as inputs to the embedding model, in deterministic order.
 *
 * This function is pure (no fs, no process) so it runs in the browser.
 * Node callers that want to include `embedding-source` file contents
 * should pass `extraTargets` from `planEmbeddingSourcesFromDisk` (Node-only).
 */
export function planEmbeddings(doc, extraTargets = []) {
    const out = [];
    if (typeof doc.intent === 'string' && doc.intent.trim().length > 0) {
        out.push({ path: 'intent', text: doc.intent });
    }
    if (Array.isArray(doc.tags)) {
        doc.tags.forEach((tag, i) => {
            if (typeof tag === 'string' && tag.length > 0) {
                out.push({ path: `tags.${i}`, text: tag });
            }
        });
    }
    if (Array.isArray(doc.features)) {
        for (const f of doc.features) {
            if (!f || typeof f.id !== 'string')
                continue;
            if (typeof f.intent === 'string' && f.intent.length > 0) {
                out.push({ path: `features.${f.id}.intent`, text: f.intent });
            }
            scanSteps(f.steps, `features.${f.id}`, out);
        }
    }
    if (Array.isArray(doc.flows)) {
        for (const f of doc.flows) {
            if (!f || typeof f.id !== 'string')
                continue;
            if (typeof f.intent === 'string' && f.intent.length > 0) {
                out.push({ path: `flows.${f.id}.intent`, text: f.intent });
            }
            scanSteps(f.steps, `flows.${f.id}`, out);
        }
    }
    for (const t of extraTargets)
        out.push(t);
    return out;
}
//# sourceMappingURL=plan.js.map